<template>
    <section>
        <!-- Separatoer slash -->
        <o-breadcrumb separator="/">
            <o-breadcrumb-item label="Home" />
            <o-breadcrumb-item label="Docs" disabled />
            <o-breadcrumb-item label="Breadcrumb" active />
        </o-breadcrumb>

        <!-- Separatoer dot -->
        <o-breadcrumb separator="•">
            <o-breadcrumb-item label="Home" />
            <o-breadcrumb-item label="Docs" disabled />
            <o-breadcrumb-item label="Breadcrumb" active />
        </o-breadcrumb>

        <!-- Separatoer chevron -->
        <o-breadcrumb separator="≻">
            <o-breadcrumb-item label="Home" />
            <o-breadcrumb-item label="Docs" disabled />
            <o-breadcrumb-item label="Breadcrumb" active />
        </o-breadcrumb>

        <!-- Separatoer arrow -->
        <o-breadcrumb separator="→">
            <o-breadcrumb-item label="Home" />
            <o-breadcrumb-item label="Docs" disabled />
            <o-breadcrumb-item label="Breadcrumb" active />
        </o-breadcrumb>
    </section>
</template>
